export default __webpack_public_path__ + "static/media/artmedica2.3943445b.png";